import { Col, Container, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import LogButton from "../../../../../components/atoms/LogButton";

function NewDador({ searchTrip = false, handleClose = () => {} }) {
  const history = useHistory();

  return (
    <Container className="d-flex flex-column align-items-center justify-content-center mt-5 h-100 ">
      <Row className="text-center mb-4">
        <Col>
          {searchTrip ? (
            <h1 className="text-primary h3 font-weight-bold">
              Para postularte primero debes completar los siguiente pasos
            </h1>
          ) : (
            <h1 className="text-primary h3 font-weight-bold">
              ¡Vamos a crear un nuevo viaje!
            </h1>
          )}
        </Col>
      </Row>

      <Container className="mb-5" style={{ maxWidth: "500px" }}>
        <Row className="justify-content-center">
          <LogButton
            variant="primary"
            onClick={() => {
              history.push("/app/travels");
            }}
            title={"Crear Viaje"}
            border="curve"
            style={{ width: "120px" }}
          />
        </Row>
      </Container>
    </Container>
  );
}

export default NewDador;
